import { inject, Injectable }    from '@angular/core';
import { Title }                 from '@angular/platform-browser';
import { ActivationEnd, Router } from '@angular/router';
import { filter }                from 'rxjs/operators';

const DEFAULT_TITLE = 'Depositor Control Panel';

@Injectable({
  providedIn: 'root'
})
export class TitleService {
  private router = inject(Router);
  private titleService = inject(Title);

  init() {
    this.router.events.pipe(
      filter(event => event instanceof ActivationEnd)
    ).subscribe((event) => {
      let routeSnapshot = (<ActivationEnd>event).snapshot;
      // Traverse over the state tree to find the last activated route, and
      // then return it to the stream
      while (routeSnapshot.firstChild) {
        routeSnapshot = routeSnapshot.firstChild;
      }
      const pageTitle = routeSnapshot.data.title ? `${routeSnapshot.data.title} - ${DEFAULT_TITLE}` : DEFAULT_TITLE;
      this.titleService.setTitle(pageTitle);
    });
  }

}
